<template>
  <div :class="{english:$i18n.locale=='en'}">
    <headLine ref="dialog" :showbar="showmenu_bar" @on-locale-change="onLocaleChange" index="5">
      {{$t('title')}}
    </headLine>
   
     <div class="banner">
         <img v-lazy="imglist[0]" alt=""> 
     </div>
     <div class="content center">
        <img v-lazy="imglist[1]" alt="" class="download_img"> 
        <h1 class="download_title">{{$t('title2')}}</h1>
        <div class="content_item_text content_item_text1" v-html="$t('text')">
        </div>
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.VRVIU.VrPlayer" class="button2 button2_Andorid" target="_blank">Andorid</a>
        <a href="javascript:void(0)" class="button2 button2_iOS gray">iOS</a>
        <a href="javascript:void(0)" class="button2 button2_geer gray"></a>
     </div>
     <footerLine></footerLine>
  </div>
</template>

<script>
import headLine from "./header"
import footerLine from "./footer"
import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
var i18n = new VueI18n({
  messages: {
    ch:{
      title:"下载Demo",
      title2:"威尔VR Demo",
      text:"下载即可体验威尔云技术处理后，多种VR场景下<br>(包括秀场、游戏、体育）适用的视频。",
      button2:"威尔VR Demo iOS版"
    },
    en:{
      title:"Download",
      title2:"VRVIU Demo",
      text:"Experience our quality 4K streaming through our demo.",
      button2:"VRVIU Demo for iOS",
    }
  }
})
export default {
  i18n:i18n,
  data(){
    return{
      imglist:[
        "../../static/images/download/BG.png",
        "../../static/images/download/main.png"
      ],
      showmenu_bar:true
    }
  },
  created(){
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
  },
  components:{
    headLine,
    footerLine
  },
  methods:{
    onLocaleChange:function(val){
      this.$i18n.locale=val;
    }
  }
}
</script>

<style scoped>
.banner{
  height: 4rem;
}
.download_img{
  width: 6.18rem;
  height: 4.02rem;
  margin-top:-2.42rem;
  margin-left: 0.44rem;
  margin-bottom:0.6rem;
}
.download_title{
  font-size: 0.65rem;
  color:rgb(40,40,40);
}
.content{
  position: relative;
  z-index: 10;
}
.content_item_text1{
  margin-top: 0.5rem!important;
}

.button2{
  width: 1.6rem;
  height: 0.8rem;
  background:rgb(0,132,255);
  font-size: 0.28rem;
  display: inline-block;
  text-align: left;
  line-height: 0.82rem;
  border-radius: 0.04rem;
  color:#fff;
  margin: 0 auto;
  margin-top: 0.7rem;
  margin-bottom: 0.2rem;
  vertical-align: middle;
  margin-bottom: 1.56rem

}
.gray{
  background-color:  #c5c5c5!important;
}
.button2_Andorid{
  background:rgb(0,132,255) url(../assets/images/download/android.png) no-repeat center center;
  background-size: 0.2rem 0.24rem;
  background-position: 0.16rem 0.27rem;
  text-indent: 0.40rem;
}
.button2_iOS{
  background:rgb(0,132,255) url(../assets/images/download/iOS.png) no-repeat center center;
  background-size: 0.2rem 0.26rem;
  background-position: 0.45rem 0.24rem;
  text-indent: 0.74rem;

}
.button2_geer{
  background:rgb(0,132,255) url(../assets/images/download/Gear VR.png) no-repeat center center;
  background-size: 0.76rem 0.26rem;
}
</style>



// WEBPACK FOOTER //
// download.vue?1ccff916